import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Filter } from "../../../../model/filters/filter";
import { Not } from "../../../../model/filters/not";

@Component({
  selector: "not",
  templateUrl: "./not.component.html",
  styleUrls: ["./not.component.css"],
})
export class NotComponent {
  @Input() filter!: Filter;
  @Output() filterChanged = new EventEmitter<Filter>();

  not: boolean = false;

  toggleNot() {}

  getModifiedFilter(): Filter {
    if (this.not) {
      const notFilter = new Not([this.filter]);
      // Preserva o filtro original
      notFilter.originalFilter = this.filter;
      return notFilter;
    }
    return this.filter;
  }
}
